<a routerLink="/">
	<ng-container *ngIf="currentLayoutType === 'dark-sidebar'">
		<img alt="Logo" src="/assets/media/icons/spotside-dark.svg" class="h-25px app-sidebar-logo-default" />
	</ng-container>
	<ng-container *ngIf="currentLayoutType !== 'dark-sidebar'">
		<img alt="Logo" src="/assets/media/icons/spotside.svg" class="h-25px app-sidebar-logo-default theme-light-show" />
		<img alt="Logo" src="/assets/media/icons/spotside.svg" class="h-25px app-sidebar-logo-default theme-dark-show" />
	</ng-container>

	<img alt="Logo" src="/assets/media/icons/spotside.svg" class="h-20px app-sidebar-logo-minimize" />
</a>
